import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1507Component } from './kymw1507.component';
import { GetCwsIconBaseData } from './api-services/get-cws-icon-base-data-service';
import { RegistCwsIconFileData } from './api-services/regist-cws-icon-file-data-service';
import { GetCodeListService } from '../../../commons/kymw02/api-services/get-code-list.service';

/**
 * 別アイコンファイル登録画面 モジュール設定クラス
 *
 * @export KYMW1507Module
 * @class KYMW1507Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1507Component,
  ],
  providers: [
    GetCwsIconBaseData,
    RegistCwsIconFileData,
    GetCodeListService
  ],
})
export class KYMW1507Module {
}
